<template>
  <v-navigation-drawer
    v-model="state"
    class="elevation-2"
    app
    :permanent="$vuetify.breakpoint.smAndUp"
    :temporary="$vuetify.breakpoint.xs"
    :mini-variant.sync="isMinimized"
  >
    <div v-if="loaded">
      <div
        style="background-color: white"
        class="d-flex align-center"
        :class="{
          'mobile-drawer-logo': $vuetify.breakpoint.xs,
          'px-7': $vuetify.breakpoint.xs
        }"
      >
        <div class="d-flex align-center justify-space-between full-width" :class="{ 'pr-8': !isMinimized }">
          <v-img height="64px" src="../../assets/logo_csp.png" contain position="center"></v-img>
          <v-icon v-if="!isMinimized" @click.stop="setMinimized">mdi-chevron-double-left</v-icon>
        </div>
      </div>
      <v-divider></v-divider>
      <StudentToolbar></StudentToolbar>
      <AdminToolbar v-if="role.name !== 'Teacher'"></AdminToolbar>
      <TeacherToolbar v-else></TeacherToolbar>
    </div>
    <div v-else>
      <v-skeleton-loader
        type="list-item-two-line, list-item-two-line, list-item-three-line, article"
      ></v-skeleton-loader>
    </div>
  </v-navigation-drawer>
</template>
<script>
import TeacherToolbar from '@/components/layout/TeacherToolbar.vue'
import AdminToolbar from '@/components/layout/AdminToolbar.vue'
import StudentToolbar from '@/components/layout/StudentToolbar.vue'
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    drawer: { type: Boolean },
    loaded: Boolean
  },
  data() {
    return {
      state: false
    }
  },
  watch: {
    drawer() {
      this.state = true
    }
  },
  components: {
    StudentToolbar,
    TeacherToolbar,
    AdminToolbar
  },
  computed: {
    ...mapState('auth', ['role']),
    ...mapState('app', ['isMinimized']),

    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '32px'
        default:
          return '64px'
      }
    }
  },
  methods: {
    ...mapActions({
      setMinimized: 'app/setMinimized'
    })
  }
}
</script>

<style scoped>
.mobile-drawer-logo {
  height: 64px;
}
</style>
